import { ChangeDetectionStrategy, Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { User } from 'src/app/shared/models/security/user';
import { Prestation, PrestationStatutColor, PrestationStatutString } from 'src/app/shared/models/prestation';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PrestationModalAjoutComponent } from '../modal/prestation-modal-ajout/prestation-modal-ajout.component';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { PrestationTypeString } from 'src/app/shared/models/prestation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { State } from 'src/app/shared/enums/state.enum';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-prestation',
	templateUrl: './list-prestation.component.html',
	styleUrls: ['./list-prestation.component.scss'],
	//changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListPrestationComponent implements OnInit {
	LABEL_INTERVENANT: string;
	LABEL_INTERVENANT_CAPITALIZED;
	LABEL_INTERVENANT_PLURIALIZED: string;

	public PrestationTypeStringEnum = PrestationTypeString;
	public PrestationStatutStringEnum = PrestationStatutString;
	public PrestationStatutColor = PrestationStatutColor;
	prestations: Prestation[] = [];
	currentPage = 1;
	totalItems;
	totalPages;

	prestationCsvFile: File = null;

	dismissible: true;
	alerts: any[] = [];
	user: User = null;

	isAddable = false;
	isImportable = true;
	isExportable = true;

	searchedInput = '';

	sortType = 'dateDebut';
	sortOrder: SortOrder = 'asc';

	selectedIntervenants: string[] = [];
	searchedText: string;

	listIntervenants: Employee[];
	listSelectedIntervenant: Employee[] = [];

	isIntervenant: boolean;

	ajoutIntervenantModalref: BsModalRef;

	itemsPerPage = 10;

	isMobile = false;
	screenWidth: number;

	isListingLoading: boolean = true;

	prestationTypeString = PrestationTypeString;
	selectedStatus: string[] = [];
	selectedType: string[] = [];

	/**
	 * Etat de la mission
	 */
	state = State;


	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.LABEL_INTERVENANT_CAPITALIZED =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.LABEL_INTERVENANT_PLURIALIZED =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENANT
			);

		this.user = this.facade.dataStorageService.getUser();

		if(this.facade.dataStorageService.getService() != null){
			this.isAddable = true;
		}

		this.getPrestations();
	}

	getPrestations(): void {
		this.isListingLoading = true;
		if(this.isIntervenant){
			this.facade.prestationService.getPrestationByIntervenant(this.facade.dataStorageService.getUser()?.id).subscribe({
					next: (prestations: Prestation[]) => {
						this.prestations = prestations;
						if(this.selectedStatus.length > 0){
							this.prestations = this.prestations.filter(e => this.selectedStatus.includes(e.statut))
						}
						if(this.selectedType.length > 0){
							this.prestations = this.prestations.filter(e => this.selectedType.includes(e.typePrestation))
						}
						this.isListingLoading = false;
					},
					error: (err: ErrorResponse) => {
						this.logger.error(err + '');
						this.isListingLoading = false;
					}
			});
			this.isAddable = false;
		}else{
			if(this.facade.dataStorageService.getService() != null){
				this.facade.prestationService.getPrestationByServiceAndRegionPagination(this.facade.dataStorageService.getService()?.id,
				this.facade.dataStorageService.getRegion()?.id, this.currentPage - 1, this.itemsPerPage, this.selectedStatus,
				this.selectedType, this.searchedInput).subscribe({
					next: (res) => {
						console.log(res);
						this.prestations = res.content;
      					this.totalItems = res.totalElements;
						this.totalPages = res.totalPages;
						this.currentPage = res.number + 1;
						this.isListingLoading = false;
					},
					error: (err: ErrorResponse) => {
						this.logger.error(err + '');
						this.isListingLoading = false;
					}
				});
			}else{
				this.isAddable = false;
				this.prestations = [];
			}
		}

	}

	// getPrestationsIntervenants(prestations: Prestation[]): Employee[] {
	// 	return prestations
	// 		.flatMap((prestation) => prestation.intervenants)
	// 		.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
	// 		.sort((a, b) => a.name.localeCompare(b.name));
	// }


	selectPrestation(prestation: Prestation): void {
		const link = ['/prestation', prestation.id];
		this.router.navigate(link);
	}

	// getPrestationsSpecialities(prestations: Prestation[]): Intervenant[] {
	// 	return prestations
	// 		.flatMap((prestation) => prestation.specialties)
	// 		.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
	// 		.sort((a, b) => a.name.localeCompare(b.name));
	// }

	// importPrestations(event: any): void {
	// 	this.isImportable = false;
	// 	this.logger.log("Import de l'prestation");
	// 	this.alerts = [];
	// 	this.prestationCsvFile = event.target.files[0];
	// 	this.facade.prestationService
	// 		.importPrestations(this.prestationCsvFile)
	// 		.subscribe({
	// 			next: (res: ImportResponse) => {
	// 				this.isImportable = true;

	// 				this.logger.log("C'est importé !");

	// 				this.getPrestations();
	// 			},
	// 			error: (err) => {
	// 				this.isImportable = true;
	// 				this.logger.log("C'est PAS importé !", err.message);
	// 				this.facade.toastService.createHttpErrorToast(
	// 					err.error.message,
	// 					err.status
	// 				);
	// 			}
	// 		});
	// }

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		const initialState = {};
		this.ajoutIntervenantModalref = this.modalService.show(
			PrestationModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutIntervenantModalref.onHide.subscribe((reason: string | any) => {
			this.getPrestations();
		});
	}

	// exportPrestations(): void {
	// 	this.facade.exportService
	// 		.exportPrestations()
	// 		.subscribe((blob) => saveAs(blob, 'prestations.csv'));
	// }

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	updateSelectedIntervenant(e: any, spe: Employee) {
		if (e.target.checked) {
			if (!this.listSelectedIntervenant.some((e) => e.id === spe.id)) {
				this.listSelectedIntervenant = [...this.listSelectedIntervenant];
				this.listSelectedIntervenant.push(spe);
			}
		} else {
			if (this.listSelectedIntervenant.some((e) => e.id === spe.id)) {
				this.listSelectedIntervenant = this.listSelectedIntervenant.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}

	calculateConsumedHours(selectedPrestation : Prestation){
		let totalHeuresActivites = 0;
		
		selectedPrestation.activites?.forEach((activite) => {
			totalHeuresActivites += activite.chargeTravail;
		})

		return totalHeuresActivites
	}

	changeStatusFilter(values: any, statut: string): void {
		// Add
		if (values.currentTarget.checked) {
			const clone = [...this.selectedStatus];
			clone.push(statut);
			this.selectedStatus = clone;
		} else {
			// Remove
			this.selectedStatus = this.selectedStatus.filter(
				(e) => e !== statut
			);
		}
	}

	changeTypeFilter(values: any, type: string): void {
		// Add
		if (values.currentTarget.checked) {
			const clone = [...this.selectedType];
			clone.push(type);
			this.selectedType = clone;
		} else {
			// Remove
			this.selectedType = this.selectedType.filter(
				(e) => e !== type
			);
		}
	}

	filterListByStatus() {
		this.currentPage = 1;
		this.getPrestations();
	}

	onItemsPerPageChange(): void {
		this.currentPage = 1;
		this.getPrestations(); 
	  }
	  

	onPageChange(pageNumber: any): void {
		this.currentPage = pageNumber;
		this.getPrestations();
	}

	onInputChange() {
		this.getPrestations();
	  }

	synchroWithIsyplanning(){
		
	}

}
